import {
  GET_CUSTOMERS,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_ERROR,
  TOGGLE_CUSTOMER_MODAL,
  ADD_CUSTOMER,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_ERROR,
  GET_CUSTOMER,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_ERROR,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_ERROR,
} from "./actionTypes";

const initialState = {
  // customers
  loadingCustomers: false,
  loadingCustomersSuccess: false,
  loadingCustomersError: null,
  customers: {},
  // add customer
  customer: {},
  addCustomerLoading: false,
  addCustomerError: null,
  addCustomerSuccess: false,
  // get customer
  getCustomerLoading: false,
  getCustomerError: null,
  getCustomerSuccess: null,
  // update customer
  updateCustomerLoading: false,
  updateCustomerError: null,
  updateCustomerSuccess: null,
};

const customers = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMERS:
      state = {
        ...state,
        addCustomerSuccess: false,
        updateCustomerSuccess: false,
        loadingCustomers: true,
        loadingCustomersSuccess: false,
        loadingCustomersError: null,
        customers: [],
        customer: {},
      };
      break;
    case GET_CUSTOMERS_SUCCESS:
      state = {
        ...state,
        loadingCustomers: false,
        loadingCustomersSuccess: true,
        loadingCustomersError: null,
        customers: action.payload,
      };
      break;
    case GET_CUSTOMERS_ERROR:
      state = {
        ...state,
        loadingCustomers: false,
        loadingCustomersSuccess: false,
        loadingCustomersError: action.payload,
        customers: [],
      };
      break;
    case TOGGLE_CUSTOMER_MODAL:
      state = {
        ...state,
        customer: {},
      };
      break;
    case ADD_CUSTOMER:
      state = {
        ...state,
        customer: {},
        addCustomerLoading: true,
        addCustomerError: null,
        addCustomerSuccess: false,
      };
      break;
    case ADD_CUSTOMER_SUCCESS:
      state = {
        ...state,
        addCustomerLoading: false,
        addCustomerError: null,
        addCustomerSuccess: true,
        customer: {},
      };
      break;
    case ADD_CUSTOMER_ERROR:
      state = {
        ...state,
        addCustomerLoading: false,
        addCustomerError: action.payload,
        addCustomerSuccess: false,
      };
      break;
    case GET_CUSTOMER:
      state = {
        ...state,
        customer: {},
        getCustomerLoading: true,
        getCustomerError: null,
        getCustomerSuccess: false,
      };
      break;
    case GET_CUSTOMER_SUCCESS:
      state = {
        ...state,
        customer: action.payload,
        getCustomerLoading: false,
        getCustomerSuccess: true,
        getCustomerError: null,
      };
      break;
    case GET_CUSTOMER_ERROR:
      state = {
        ...state,
        getCustomerError: action.payload,
        getCustomerLoading: false,
        getCustomerSuccess: false,
      };
      break;
    case UPDATE_CUSTOMER:
      state = {
        ...state,
        updateCustomerLoading: true,
        updateCustomerError: null,
        updateCustomerSuccess: false,
      };
      break;
    case UPDATE_CUSTOMER_SUCCESS:
      state = {
        ...state,
        updateCustomerLoading: false,
        updateCustomerSuccess: true,
        updateCustomerError: null,
        customer: {},
      };
      break;
    case UPDATE_CUSTOMER_ERROR:
      state = {
        ...state,
        updateCustomerLoading: false,
        updateCustomerError: action.payload,
        updateCustomerSuccess: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default customers;
